<template>
	<div class="modal-wrap">
		<div class="content-top">
			<div class="container-fluid">
				<div class="row">
					<div class="display-flex-center justify-content-between full-width" style="align-items: flex-start;">
						<div class="d-flex content-d-flex ">
							<div class="inner-back js-back ml-lg-5 ml-md-3 ml-sm-2" @click="handleOffModal">
								<span class="icon-arrow-left font-size-16 color-light"><span class="path1"></span><span class="path2"></span></span>
							</div>
						</div>
						<div class="inner-title display-flex">
							<a href="javascript:;" class="inner-title-view-a ">
								<img v-if="docPreview.path && checkVideo(docPreview.path)" src="@/assets/images/youtobe.png" alt="Video" />
								<img v-else-if="docPreview.path && checkPowerpoint(docPreview.path)" src="@/assets/images/power.png" alt="Powerpoint" />
								<img v-else-if="docPreview.path && checkPdf(docPreview.path)" src="@/assets/images/pdf.png" alt="Pdf" />
								<img v-else src="@/assets/images/document1.png" alt="Word" />
							</a>
							<span class="docPreview-span font-size-18">{{ docPreview.name }}</span>
						</div>
						<div class="d-flex content-d-flex mr-lg-5 mr-md-3 mr-sm-2">
							<div class="inner-zoom" v-if="!checkVideo(docPreview.path) && !checkImage(docPreview.path) && checkPowerpoint(docPreview.path)">
								<span @click="scale -= scale > 0.2 ? 0.1 : 0"><i class="fa fa-minus"></i></span>
								<span>{{ formattedZoom }} %</span>
								<span @click="scale += scale < 2 ? 0.1 : 0"><i class="fa fa-plus"></i></span>
							</div>
							<div class="inner-up" v-if="!checkImage(docPreview.path) && !docPreview.linkViewFull">
								<span>
									<a href="javascript:;" @click="downloadDocs(docPreview.path, docPreview.name)">
										<img class="img-down" src="@/assets/images/down3.png" />
									</a>
								</span>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="content-center position-rel" :class="`content-type-${checkTypeDocs(docPreview.path)}`">
			<div id="content_viewer" class="inner-img" :class="`inner-type-${docPreview.path ? checkTypeDocs(docPreview.path) : ''} ${relateMedia && relateMedia.length > 0 ? 'has-more' : ''} ${docPreview.bookInfo && docPreview.bookInfo.fileName && docPreview.bookInfo.totalPage ? 'has-book' : ''}`">
				<div class="overlay" @click="handleOffModal"></div>
				<PreviewBookImg
          v-if="docPreview.bookInfo && docPreview.bookInfo.fileName && docPreview.bookInfo.totalPage"
          :fileName="docPreview.bookInfo.fileName"
          :totalPage="docPreview.bookInfo.totalPage"
          :fullPath="docPreview.linkViewFull"
          :isLocal="docPreview.isLocal"
          :zoomData="scale"
        />
				<PreviewVideo 
					v-else-if="checkVideo(docPreview.path)"
					:pathView="docPreview.linkViewFull ? docPreview.pathView : `${appUrl}${docPreview.path}`" 
					:mediaMore="relateMedia && relateMedia.length > 0 ? true : false"
				/>
				<PreviewPdf 
					v-else-if="checkPdf(docPreview.path) || checkWord(docPreview.path)" 
					:pathView="docPreview.linkViewFull ? docPreview.pathView : `${appUrl}${docPreview.pathView ? docPreview.pathView : docPreview.path}`" 
					:zoomData="scale" :class="{'view-default': scale === 1}" 
				/>
				<Previewpptx 
					v-else-if="checkPowerpoint(docPreview.path)" 
					:pathView="docPreview.linkViewFull ? docPreview.pathView : `${appUrl}${docPreview.pathView ? docPreview.pathView : docPreview.path}`" 
					:zoomData="scale" 
					:class="{'view-default': scale === 1}" 
				/>
				<PreviewImage 
					v-else-if="checkImage(docPreview.path)" 
					:pathView="docPreview.linkViewFull ? docPreview.pathView : `${appUrl}${docPreview.pathView ? docPreview.pathView : docPreview.path}`" 
				/>
				<PreviewYoutube 
					v-else-if="checkYoutube(docPreview.path)" 
					:pathView="docPreview.pathView"
					:autoplay="true"
					:mediaMore="relateMedia && relateMedia.length > 0 ? true : false"
				/>
				<PreviewAudio 
					v-else-if="checkAudio(docPreview.path)" 
					:pathView="docPreview.linkViewFull ? docPreview.pathView : `${appUrl}${docPreview.pathView ? docPreview.pathView : docPreview.path}`"
					:autoPlay="true" 
				/>
				<h2 v-else class="text-center color-light font-sanpro-semibold">Không tìm thấy tài liệu hiển thị</h2>
			</div>
		<!-- 	<div class="sidebar__media__list sidebar__media__list--slider position-rel" v-if="relateMedia && relateMedia.length > 0">
				<h3 class="sidebar__media__list__title font-sanpro-semibold color-light font-size-22">Xem thêm</h3>
				<swiper :options="{slidesPerView: 3, spaceBetween: 20, slidesPerGroup: 1, grabCursor: true, loop: false, loopFillGroupWithBlank: true, breakpoints: {767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 575: {slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 } }, navigation: {nextEl: `.ebook__next__0`, prevEl: `.ebook__prev__0`}}" @slideNextTransitionEnd="handleNextMedia" ref="swiper_relate">
        	<swiperSlide 
        		class="item position-rel" 
        		v-for="(item, loc) of relateMedia" 
        		:key="`book__${loc}`"
        		v-if="item.linkUrl && item.linkUrl !== docPreview.pathView"
        	>
            <div class="item__wrap" @click="viewMedia(item)">
							<div class="item__media">
                <img v-if="checkVideo(item.linkUrl)" :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : img404" alt="Học liệu">
	    					<PreviewImage 
  								v-else-if="checkImage(item.linkUrl)" 
  								:pathView="isFullLink(item.linkUrl) ? item.linkUrl : `${appUrl}${item.linkUrl}`" 
  							/>
  							<PreviewYoutube 
  								v-else-if="checkYoutube(item.linkUrl)" 
  								:pathView="item.linkUrl"
  							/>
  							<PreviewAudio
                  class="evt-none"
  								v-else-if="checkAudio(item.linkUrl)" 
  								:pathView="isFullLink(item.linkUrl) ? item.linkUrl : `${appUrl}${item.linkUrl}`" 
  							/>
  	    			</div>
  	    				<h4 class="item__title font-size-15 color-light margin-0">
  	    					{{ item.title }}
  	    				</h4>
              </div>
            </swiperSlide>
        	<div class="swiper-button-prev ebook__prev__0" slot="button-prev"></div>
        	<div class="swiper-button-next ebook__next__0" slot="button-next"></div>
        </swiper>
    	</div> -->
		</div>
	</div>
</template>

<script>
	import PreviewVideo from './PreviewVideo.vue'
	import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
	import { APP_CONFIG } from '@/utils/constants'
	import mixinsFiles from './mixinsFiles'
	// import pdf from 'pdfvuer'
	import PreviewPdf from './PreviewPdf.vue'
	// import PreviewDoc from './PreviewDoc.vue'
	import Previewpptx from './Previewpptx.vue'
	import PreviewImage from './PreviewImage.vue'
	import PreviewYoutube from './PreviewYoutube.vue'
	import PreviewAudio from './PreviewAudio.vue'
	import PreviewBookImg from "./PreviewBookImg.vue";
	// import { swiper, swiperSlide } from 'vue-awesome-swiper'
	// import 'swiper/dist/css/swiper.css'
	// import { SET_PARAM_SEARCH_RELATE_MEDIA, STORE_KEY as STORE_KEY_BOOK } from '@/modules/ebooks/_store/constants'
  const img404 = require(`@/assets/images/img_404.jpg`)
	// var mammoth = require("mammoth");

	export default {
		name: 'ModalPreviewDocMedia',
		mixins: [ mixinsFiles ],
		props: {
			mediaMore: Boolean
		},
		components: { 
	    	PreviewVideo,
	    	PreviewPdf,
	    	Previewpptx,
	    	PreviewImage,
	    	PreviewYoutube,
	    	PreviewAudio,
	    	PreviewBookImg,
	    	// swiper, 
   			// swiperSlide,
	    },
		data () {
			return {
				appUrl: APP_CONFIG.bookCdnUrl,
				cdnUrl: APP_CONFIG.cdnUrl,
        urlImgCms: APP_CONFIG.urlPlatformCmsImg,
				scale: 1,
				relateMedia: [],
				mediaRelateNotdata: false,
        img404
			}
		},
		computed: {
			...mapGetters({ docPreview: 'common/docPreview' }),
			// ...mapState(STORE_KEY_BOOK, ['paramSearchRelateMedia']),
			formattedZoom () {
        return Number.parseInt(this.scale * 100);
      },
		},
		// watch: {
		// 	'paramSearchRelateMedia': 'getDataRelateMedia'
		// },
		mounted() {
			// this.mediaMore && this.getDataRelateMedia();
		},
		beforeDestroy() {
			this.relateMedia = [];
			this.mediaRelateNotdata = false;
		},
		methods: {
			...mapActions('common', ['toggleModalPreview', 'setDocPreviewContent']),
			// ...mapActions(STORE_KEY_BOOK, ['getRelateMedia']),
			// ...mapMutations(STORE_KEY_BOOK, ['SET_PARAM_SEARCH_RELATE_MEDIA']),

			handleOffModal() {
				this.toggleModalPreview(false)
				this.setDocPreviewContent({})
			},

			viewMedia(data) {
				let dataForPreview = {type: '', path: data.linkUrl, pathView: data.linkUrl, name: data.title};
        if(data.linkUrl.includes('http')) {
            dataForPreview['linkViewFull'] = true;
        }
        this.setDocPreviewContent(dataForPreview);
			},

			handleNextMedia(evt) {
				const swiperRef = this.$refs.swiper_relate.swiper;
				const indexActive = swiperRef.isEnd;
				if(swiperRef.isEnd && !this.mediaRelateNotdata) {
					this.SET_PARAM_SEARCH_RELATE_MEDIA({...this.paramSearchRelateMedia, pageIndex: this.paramSearchRelateMedia.pageIndex + 1})
				}
			},

			getDataRelateMedia() {
				// console.log('GET RELATEL')
				let self = this;
				if(self.paramSearchRelateMedia.bookId && self.paramSearchRelateMedia.bookId > 0) {
					self.getRelateMedia(self.paramSearchRelateMedia).then(res => {
						// console.log('Get relate done: ', res)
						if(res) {
							self.relateMedia = [...self.relateMedia, ...res];
						}
						if(res.length === 0) {
							self.mediaRelateNotdata = true;
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	
	.content-top, .content-center {
		position: relative;
		z-index: 10!important;
	}
    .content-center{
    	height: 100vh;
    	margin: 0 auto!important;
	    padding: 5vh 0;
	    // background: rgba(64, 80, 94, 0.8);
    }
    .inner-img {

    	&:not(.inner-type-pptx) {
			overflow-y: auto;
			max-height: 80vh;
    	}

    	&.has-book {
    		overflow-y: inherit;
    	}

    	&.has-more {
			max-height: calc(85vh - 225px);
    	}

    	&.inner-type-doc {
    		background: #ccc;
    	}

    	&.inner-type-img, &.inner-type-audio {
    		height: 80vh;
    		display: flex;
    		align-items: center;
    		justify-content: center;
    	}
	}
	.content-type-img, .content-type-video {
		.inner-img {
			background: transparent;
		}

		img {
			max-height: 80vh;
		}

		&.has-more {
			img {
				max-height: calc(80vh - 245px);
			}
		}

	}
	.inner-up {
		margin-left: 20px;

		@media screen and ( max-width: 575px ) {
			margin-left: 10px;
		}
	}
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: transparent;
		z-index: 11;

		~ * {
			position: relative;
			z-index: 12;
		}
	}
	.sidebar__media__list--slider {
		z-index: 12;
		max-width: 80vw;
		margin: 40px auto 20px;

		.item {
			margin-bottom: 0!important;

			&__wrap {

				&:before {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 1;
					background: rgba(0,0,0, .0);
				}
			}
		}

		.sidebar__media__list {
			&__title {
				margin: 0 0 25px;
			}
		}
	}
	.ebook__next__0, .ebook__prev__0 {
		height: 97.5%;
		top: 0;
		margin: 0;
		background-position: center;
		width: 50px;
		background-color: rgba(0,0,0,.3); 
	}
	.ebook__prev__0 {
		left: 0;
		border-radius: 6px 0 0 6px;
	}
	.ebook__next__0 {
		right: 0;
		left: auto;
		border-radius: 0 6px 6px 0;
	}
	.has-more{
		margin: 0 60px;
		@media screen and (max-width: 1024px){
			margin: 0 42px;	
		}
		@media screen and (max-width: 768px){
			margin: 0 30px;	
		}
		@media screen and (max-width: 575px){
			margin: 0 23px;	
		}
		@media screen and (max-width: 425px){
			margin: 0 0px;	
		}
	}

	.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
		pointer-events: auto!important;
	}

	@media screen and ( max-width: 575px ) {
		.sidebar__media__list {

			&--slider {
				margin: 15px auto 10px;
			}

			&__title {
				font-size: 18px;
			}
		}

		.ebook__next__0, .ebook__prev__0 {
			width: 30px;
		}
	}
</style>